export const gpaRoutesData = [
    {
        name: 'CSE',
        to: '/gpa/cse',
        expansion: 'Computer Science and Engineering'
    },
    {
        name: 'IT',
        to: '/gpa/it',
        expansion: 'Information Technology'
    },
    {
        name: 'AIML',
        to: '/gpa/aiml',
        expansion: 'Artificial Intelligence And Machine Learning'
    },
    {
        name: 'ADS',
        to: '/gpa/ads',
        expansion: 'Artificial Intelligence and Data Science'
    },
    {
        name: 'ECE',
        to: '/gpa/ece',
        expansion: 'Electronics and Communication Engineering'
    },
    {
        name: 'EEE',
        to: '/gpa/eee',
        expansion: 'Electrical and Electronics Engineering'
    },
    {
        name: 'MECH',
        to: '/gpa/mech',
        expansion: 'Mechanical Engineering'
    },
    {
        name: 'CIVIL',
        to: '/gpa/civil',
        expansion: 'Civil Engineering'
    },
    {
        name: 'BME',
        to: '/gpa/auto',
        expansion: 'Bio Medical Engineering'
    },
    // adding 5 deparments
    {
        name: 'FT',
        to: '/gpa/ft',
        expansion: 'Fashion Technology'
    },
    {
        name: 'MCT',
        to: '/gpa/mct',
        expansion: 'Mechatronics Engineering'
    },
    {
        name: 'CSD',
        to: '/gpa/csd',
        expansion: 'Computer Science and Design'
    }
]

